export default __webpack_public_path__ + "static/media/what_we_can_do.6f808e1a.jpg";